import React from 'react';
import { Link } from 'react-router-dom';
import HeaderOne from '../common/header/HeaderOne';
import FooterOne from '../common/footer/FooterOne';
import SEO from '../common/SEO';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import { AnimationOnScroll } from 'react-animation-on-scroll';

const ErrorPage = () => {

    return (
        <>
        <SEO metaTitle="Page Not Found | ITCODE InfoTech" metaRobots="noindex, follow" />
        <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <div className="error-page onepage-screen-area">
                    <div className="container">
                        <div className="row align-items-center">
                        <div className="col-lg-6">
                        <AnimationOnScroll  animateIn="slideInUp" duration={1} delay={300} animateOnce={true}>
                            <div className="content">
                                <h1 className="title">Page not found</h1>
                                <p>The page you're looking for doesn't exist or may have been moved. Double-check the URL, or use one of the links below to find what you need.</p>
                                <div className="d-flex flex-wrap gap-3 align-items-center">
                                    <Link to={process.env.PUBLIC_URL + "/"} className="axil-btn btn-fill-primary">Go Back Home</Link>
                                    <Link to={process.env.PUBLIC_URL + "/blogs"}>Blog</Link>
                                    <Link to={process.env.PUBLIC_URL + "/service"}>Services</Link>
                                    <Link to={process.env.PUBLIC_URL + "/contact"}>Contact</Link>
                                </div>
                            </div>
                        </AnimationOnScroll>
                        </div>
                        <div className="col-lg-6">
                        <AnimationOnScroll  animateIn="zoomIn" duration={1} delay={300} animateOnce={true}>
                            <div className="thumbnail">
                                <img src={process.env.PUBLIC_URL + "/images/others/404.png"} alt="404 error illustration" />
                            </div>
                        </AnimationOnScroll>
                        </div>
                        </div>
                    </div>
                    <ul className="shape-group-8 list-unstyled">
                        <li className="shape shape-1">
                            <img src={process.env.PUBLIC_URL + "/images/others/bubble-9.png"} alt="Bubble" />
                        </li>
                        <li className="shape shape-2">
                            <img src={process.env.PUBLIC_URL + "/images/others/bubble-27.png"} alt="Bubble" />
                        </li>
                        <li className="shape shape-3">
                            <img src={process.env.PUBLIC_URL + "/images/others/line-4.png"} alt="Line" />
                        </li>
                    </ul>
                </div>
            </main>
            <FooterOne parentClass="" />
        </>
    )
}

export default ErrorPage;